@use '../../../../styles/abstract/variables/breakpoints'as *;

:host {
    --menu-horizontal-padding: 4px;
    --menu-vertical-padding: 4px;
    --menu-border-radius: 16px;
    --menu-min-width: 112px;
    --menu-max-width: 280px;
    --menu-divided-zones-border-radius: 8px;
    --item-border-radius: 4px;
    --item-separated-border-radius: 12px;
    --item-separation: 8px;
    --item-horizontal-padding: 12px;
    --icon-size: 20px;

    position: fixed;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    // display: none;
    flex-direction: column;

    width: max-content;
    min-width: var(--menu-min-width);
    max-width: var(--menu-max-width);
    height: fit-content;
    flex-direction: column;
    border-radius: var(--menu-border-radius);
    overflow: hidden;

    app-menu-item-dumb:last-of-type {
        --menu-item-shape: var(--menu-border-radius, 4px) var(--menu-border-radius, 4px) var(--item-separated-border-radius, 12px) var(--item-separated-border-radius, 12px);
    }

    app-menu-item-dumb:first-of-type:last-of-type {
        --menu-item-shape: var(--item-separated-border-radius, 12px);
    }

    @include respond-up("large") {
        --menu-max-width: 320px;
    }
}

:host([k_open]) {
    // display: flex;
    visibility: visible;
    pointer-events: auto;
    opacity: 1;
}

::slotted(app-menu-item-dumb:first-of-type) {
    --menu-item-shape: var(--item-separated-border-radius, 12px) var(--item-separated-border-radius, 12px) var(--item-border-radius, 4px) var(--item-border-radius, 4px);
}

::slotted(app-menu-item-dumb:last-of-type) {
    --menu-item-shape: var(--item-border-radius, 4px) var(--item-border-radius, 4px) var(--item-separated-border-radius, 12px) var(--item-separated-border-radius, 12px);
}

.scroll-wrapper {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    padding: var(--menu-vertical-padding, 4px) var(--menu-horizontal-padding, 4px) !important;
}